export {
  Action,
  init,
  update,
  State,
  getNotesConfigurationActions,
  hasChanged
} from "./state";
export { NotesView } from "./view";
